import Axios from "axios";

export function saveDownloadedFile(response, shouldOpenFile, fileName, type = "application/pdf") {
    let newBlob = new Blob([response.data], { type: type });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, fileName);
        return;
    }

    if (shouldOpenFile) {
        const data = window.URL.createObjectURL(newBlob);
        window.open(data);
    } else {
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = data;
        link.download = fileName || "file.pdf";
        link.click();
        setTimeout(function() {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    }
}

export function downloadFile(url, axiosOptions = {}, shouldOpenFile, fileName) {
    return Axios.get(url, {
        ...axiosOptions,
        responseType: "arraybuffer",
    }).then(response => {
        if (fileName == null) {
            fileName = response.headers["x-file-name"]?.replace(/"/g, "");
        }
        let contentType = "application/octet-stream";
        if (fileName?.indexOf(".pdf") >= 0) {
            contentType = "application/pdf";
        }
        saveDownloadedFile(response, shouldOpenFile, fileName, contentType);
    });
}

export function postAndDownloadFile(url, data, axiosOptions = {}, shouldOpenFile, fileName) {
    Axios.post(url, data, {
        headers: {
            "Content-Type": "application/json",
        },
        ...axiosOptions,
        responseType: "arraybuffer",
    }).then(response => {
        saveDownloadedFile(response, shouldOpenFile, fileName, "text/csv");
    });
}

export function postAndDownloadFilee(url, axiosOptions = {}, shouldOpenFile, fileName) {
    Axios.post(url, {
        headers: {
            "Content-Type": "application/json",
        },
        ...axiosOptions,
        responseType: "arraybuffer",
    }).then(response => {
        saveDownloadedFile(response, shouldOpenFile, fileName, "text/csv");
    });
}

export function downloadGeneratedPdf(encounterId, pdfToPrint, fileName, shouldOpenFile = true) {
    return downloadFile(`api/pdf/encounter/${encounterId}/${pdfToPrint}`, {}, shouldOpenFile, fileName);
}
export function downloadSignedPdf(documentID, shouldOpenFile = true) {
    return downloadFile(`api/pdf/document/${documentID}`, shouldOpenFile);
}

export function downloadGeneratedPdfs(encounterId, pdfsToPrint, fileName, shouldOpenFile = true) {
    return Axios.put(`api/pdf/encounter/${encounterId}`, pdfsToPrint, {
        responseType: "arraybuffer",
    }).then(response => {
        saveDownloadedFile(response, shouldOpenFile, fileName);
    });
}

export function downloadPdfTemplates(pdfsToPrint, fileName, shouldOpenFile = true) {
    return Axios.put(`api/pdf/templates`, pdfsToPrint, {
        responseType: "arraybuffer",
    }).then(response => {
        saveDownloadedFile(response, shouldOpenFile, fileName);
    });
}
